import socialActionTracking from 'common/tracking/socialActionTracking';

export const trackFollowUser = () => socialActionTracking('follow_user', 'add');

export const trackUnfollowUser = () =>
  socialActionTracking('unfollow_user', 'delete');
